import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

const isDummy =
  !supabaseUrl ||
  !supabaseAnonKey ||
  supabaseUrl?.trim() === '' ||
  supabaseAnonKey?.trim() === '' ||
  supabaseUrl === 'https://dummy.supabase.co' ||
  supabaseAnonKey === 'dummykey';

export const supabase = isDummy
  ? null
  : createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
      },
    });

export const isSupabaseConfigured = () => !isDummy && supabase !== null;

export const removeSupabaseChannel = (channel) => {
  if (!supabase || !channel) return;
  supabase.removeChannel(channel).catch(() => {});
};
